import { Component, Input, OnInit } from '@angular/core';
import { UvxTableModel } from './uvx-table.model';
import { HostListener } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { Output } from '@angular/core';

@Component({
  templateUrl: './uvx-table.component.html',
  styleUrls: ['./uvx-table.component.scss'],
  selector: 'uvx-table'
})
export class UvxTableComponent implements OnInit {

    @Input() data:UvxTableModel = new UvxTableModel();

    // Logic for lazy loading
    @Input() lazyLoad:boolean = false;
    @Input() pageSize:number = 50;
    @Input() currentPage:number = 1;

    @Output() onRowClick = new EventEmitter<any>();

    currentSortColumn:any = null;

    @HostListener('scroll', ['$event'])
	  onScroll(event: any) {
      const position = Math.round(
        event.target.offsetHeight + event.target.scrollTop
      );
      const bottom = event.target.scrollHeight-10;
      const atBottom = (position + 50) >= bottom; // Add 50px buffer to bottom
      if (atBottom && this.data.data.length > 0 && this.pageSize * this.currentPage < this.data.data.length) {
        this.currentPage++;
      }
	  }

    get hasFilterableRows(){
      return this.data.columns.filter(h => h.filterable).length > 0;
    }

    get visibleData(){
      if(this.lazyLoad){
        const start = 0;
        const end = this.currentPage * this.pageSize;
        var data = this.data.data;
        data = data.filter(x => {
          var show = true;
          this.data.columns.forEach(c => {
            if(c.filterable && c.filter){
              if(!String(x[c.field]).toLocaleLowerCase().includes(String(c.filter).toLocaleLowerCase())){
                show = false;
              }
            }
          });
          return show;
        });
        return data.slice(start, end);
      }
      return this.data.data;
    }

    get hasValues(){
      return this.data.data.length > 0;
    }

    constructor(){}

    ngOnInit(): void {

    }

    onRowClicked(row:any){
      this.onRowClick.emit(row);
    }

    sortBy(column:any){
      if(this.currentSortColumn && this.currentSortColumn.field == column.field){
        this.data.data.reverse();
        return;
      }
      if(this.currentSortColumn && this.currentSortColumn.field != column.field){
        this.data.data.reverse();
      }
      this.currentSortColumn = column;
      this.data.data.sort((a:any, b:any) => { 
        if(String(a[column.field]).toLocaleLowerCase() < String(b[column.field]).toLocaleLowerCase()) { return -1; }
        if(String(a[column.field]).toLocaleLowerCase() > String(b[column.field]).toLocaleLowerCase()) { return 1; }
        return 0;
      });
    }

    exportCSV(){
      var csv = "";
      this.data.columns.forEach(c => {
        csv += c.header + ",";
      });
      csv = csv.slice(0, -1);
      csv += "\n";
      this.data.data.forEach(d => {
        this.data.columns.forEach(c => {
          csv += d[c.field] + ",";
        });
        csv = csv.slice(0, -1);
        csv += "\n";
      });
      var hiddenElement = document.createElement('a');
      hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
      hiddenElement.target = '_blank';
      hiddenElement.download = 'export.csv';
      hiddenElement.click();
    }
}